/** Type of accrued time. */
export enum WorktimeImportAccrualType {
  /** Holiday accrual. Typically registered for a month. */
  HolidayAccrual = "holidayAccrual",
  /** Employees earn paid time off as 'accrued days off'*/
  AccruedDaysOff = "accruedDaysOff",
}

(()=>{ /* Snowpack Noop HACK for: https://github.com/snowpackjs/snowpack/issues/3585 */ })();